"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROFILE_PICTURE_SIZES_TO_PIXELS = exports.ProfilePictureSize = void 0;
var ProfilePictureSize;
(function (ProfilePictureSize) {
    ProfilePictureSize["LARGE"] = "LARGE";
    ProfilePictureSize["MEDIUM"] = "MEDIUM";
    ProfilePictureSize["SMALL"] = "SMALL";
    ProfilePictureSize["XSMALL"] = "XSMALL";
})(ProfilePictureSize = exports.ProfilePictureSize || (exports.ProfilePictureSize = {}));
exports.PROFILE_PICTURE_SIZES_TO_PIXELS = {
    [ProfilePictureSize.LARGE]: 72,
    [ProfilePictureSize.MEDIUM]: 42,
    [ProfilePictureSize.SMALL]: 35,
    [ProfilePictureSize.XSMALL]: 24,
};
//# sourceMappingURL=constants.js.map